jQuery(document).ready(function($) {
    if ($('body.page-template-page-resources').length == 0 && $('body.page-template-page-resources-subpage').length == 0) return;
    resourcesHandler.init();
    blogsHandler.init();
})
